import { css } from 'styled-components';

const BackgroundImageRoot = css({});

const BackgroundImagePosition = {
    topLeft: css`
        object-position: left top;
        top: 0;
        bottom: auto;
    `,
    topCenter: css`
        object-position: center top;
        top: 0;
        bottom: auto;
    `,
    topRight: css`
        object-position: right top;
        top: 0;
        bottom: auto;
    `,
    centerLeft: css`
        object-position: left center;
        top: auto;
        bottom: auto;
    `,
    centerCenter: css`
        object-position: center center;
        top: auto;
        bottom: auto;
    `,
    centerRight: css`
        object-position: right center;
        top: auto;
        bottom: auto;
    `,
    bottomLeft: css`
        object-position: left bottom;
        top: auto;
        bottom: 0;
    `,
    bottomCenter: css`
        object-position: center bottom;
        top: auto;
        bottom: 0;
    `,
    bottomRight: css`
        object-position: right bottom;
        top: auto;
        bottom: 0;
    `,
};

const styles = {
    root: BackgroundImageRoot,
    position: BackgroundImagePosition,
};

export default styles;
